import { ColumnDef } from '@tanstack/react-table'

import { CurrencyPaymentItem } from '@/interfaces/billing'
import {
  formatCurrency,
  formatDateForTableSeparatedDateAndTime,
} from '@/utils/helpers'
import { CurrencyPaymentStatusBadge } from '@/components/misc/badges/CurrencyPaymentStatusBadge'

export const getColumns = (): ColumnDef<CurrencyPaymentItem>[] => [
  {
    accessorKey: 'paymentNumber',
    header: 'No. de pago',
    cell: ({ row }) => (
      <span className="font-medium">
        {row.original.paymentNumber ? `P-${row.original.paymentNumber}` : '-'}
      </span>
    ),
    enableHiding: false,
  },

  {
    accessorKey: 'amount',
    header: 'Monto',
    cell: ({ row }) => (
      <div>
        <span className="font-medium">
          {formatCurrency(
            Number(row.original.amount),
            row.original.codeCurrency
          )}
        </span>
      </div>
    ),
    enableHiding: false,
  },
  {
    accessorKey: 'paymentGateway',
    header: 'Método de pago',
    cell: ({ row }) => <div>{row.original.paymentGateway?.name}</div>,
    enableHiding: false,
  },
  {
    id: 'status',
    header: 'Estado',
    cell: ({ row }) => (
      <CurrencyPaymentStatusBadge
        isARefund={row.original.isARefund}
        isPartialPayment={row.original.isPartialPayment}
        isPrepaidPayment={row.original.isPrepaidPayment}
        paymentConfirmed={row.original.paymentConfirmed}
      />
    ),
  },
  {
    accessorKey: 'createdAt',
    header: 'Fecha',
    cell: ({ row }) => {
      const { date, time } = formatDateForTableSeparatedDateAndTime(
        row.original.createdAt
      )
      return (
        <div>
          <div>{date}</div>
          <div className="text-xs text-muted-foreground">{time}</div>
        </div>
      )
    },
    enableHiding: false,
  },

  {
    accessorKey: 'observations',
    header: 'Observaciones',
    cell: ({ row }) => <div>{row.original.observations || '-'}</div>,
    enableHiding: false,
  },
]
